import styled, { css } from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css.js'
import vars from '@/assets/styles/vars'

const Toggle = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 16px;
  height: 15px;
  color: var(--color-decor);
  transition: color 0.3s ease;

  &:hover {
    color: var(--color-decor-hover);
  }
`

Toggle.Inner = styled.span`
  position: relative;
  display: block;
  width: 16px;
  height: 1px;
  transform: ${props => (props.isOpen ? 'rotate(225deg)' : '')};
  transition-timing-function: ${props =>
    props.isOpen
      ? 'cubic-bezier(0.215, 0.61, 0.355, 1)'
      : 'cubic-bezier(0.55, 0.055, 0.675, 0.19)'};
  transition-duration: 0.22s;
  transition-property: transform;
  transition-delay: ${props => (props.isOpen ? '0.12s' : '')};
  background-color: currentColor;

  &::before,
  &::after {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    transition-timing-function: ease;
    transition-duration: 0.15s;
    transition-property: transform;
    background-color: currentColor;
  }

  &::before {
    top: ${props => (props.isOpen ? '0' : '-6px')};
    transition: ${props =>
      props.isOpen
        ? 'top 0.1s ease-out, opacity 0.1s ease-out 0.12s'
        : 'top 0.1s ease-in 0.25s, opacity 0.1s ease-in'};
    opacity: ${props => (props.isOpen ? 0 : '')};
  }

  &::after {
    bottom: ${props => (props.isOpen ? 0 : '-6px')};
    transition: ${props =>
      props.isOpen
        ? 'bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s'
        : 'bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19)'};
    transform: ${props => (props.isOpen ? 'rotate(-90deg)' : '')};
  }
`

export default Toggle
